import {APIURL} from '../../constants';
import axios from 'axios';

export default {
    namespaced: true,
    actions: {
        updateResources(context, payload)
        {
            axios.put(`${APIURL}status/${payload}`)
            .then((res) => {
                if(payload === 'files')
                {
                    context.dispatch('updateResources', 'routedata');
                }

                if(payload === 'routedata' || payload === 'routelines')
                {
                    context.dispatch('updateResources', 'maptiles')
                }
            })
            .catch((err) => {

            });
        },


    },


    mutations: {},
    getters: {}
}